import { useScrollReveal } from "@/hooks/useScrollReveal";
import { cn } from "@/lib/utils";

export function Reveal({ children, delay = 0, className, as = "div", ...props }) {
  const [ref, visible] = useScrollReveal();
  const Tag = as;
  return (
    <Tag
      ref={ref}
      className={cn(visible ? "reveal-visible" : "reveal-hidden", className)}
      style={{ transitionDelay: visible ? `${delay}ms` : "0ms" }}
      {...props}
    >
      {children}
    </Tag>
  );
}
